import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/_current/environment';
import { ChallengeBody } from '@skyfit/core-data-library';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminChallengesV2Service {
  private readonly http = inject(HttpClient);

  getChallenge(challengeId: number): Observable<ChallengeBody> {
    const path = `${environment.aaptivServiceUrl}/api/content/v1/challenges/${challengeId}`;
    return this.http.get<ChallengeBody>(path);
  }

  createChallenge(challenge: ChallengeBody): Observable<ChallengeBody> {
    const path = `${environment.aaptivServiceUrl}/api/content/v1/challenges`;
    this.prepareChallenge(challenge);
    return this.http.post<ChallengeBody>(path, challenge);
  }

  updateChallenge(
    challengeId: number,
    challenge: ChallengeBody
  ): Observable<ChallengeBody> {
    const path = `${environment.aaptivServiceUrl}/api/content/v1/challenges/${challengeId}`;
    this.prepareChallenge(challenge);
    return this.http.put<ChallengeBody>(path, challenge);
  }

  deleteGroupChallenge(challengeId: number) {
    const url = `${environment.aaptivServiceUrl}/api/content/v1/challenges/${challengeId}`;
    return this.http.delete(url);
  }

  private prepareChallenge(challenge: ChallengeBody): void {
    if (challenge.teams) {
      for (const team of challenge.teams) {
        if (team.groupChallengeTeamId < 0) {
          team.groupChallengeTeamId = undefined;
        }
      }
    }
  }
}
